export default class K
{
    downloadData(data) {
        function objectToCsv(datos, name) {
            let headers = null
            let moreThanOne = false
            if (typeof datos[0] === 'undefined') {
                
                headers = Object.keys(datos);
            } else {
                moreThanOne = true
                headers = Object.keys(datos[0]);
            }
    
            const csvRows = [];
            
            // Generate header row
            csvRows.push(headers.join(','));
            
            // Generate data rows
            if (moreThanOne === true) {
                datos.forEach((item) => {
                    const values = headers.map((header) => {
                    // Convert collections property to JSON string
                    if (header === 'collections') {
                        return Object.keys(item[header]).join(' - ');
                    }
                    return item[header];
                    });
                    csvRows.push(values.join(','));
                });

                // Combine rows into CSV content
                let csvContent = csvRows.join('\n');

                const csv = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', csv);
                link.setAttribute('download', name + "-data");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                const csvHeader = Object.keys(datos).join(',');
                const csvValues = Object.values(datos).join(',');

                const csv = `${csvHeader}\n${csvValues}`;

                const encodedUri = encodeURI(csv);
                const link = document.createElement('a');
                link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodedUri);
                link.setAttribute('download', name + "-data");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            
          }
          
          // Convert "data_blocks" to CSV
          objectToCsv(data.data_blocks, "data_blocks");
          
          // Convert "linechart" to CSV
          objectToCsv(data.linechart, "linechart");
          
          // Convert "table_user" to CSV
          objectToCsv(data.table_user, "table_users");
          
          // Convert "table_collections" to CSV
          objectToCsv(data.table_collections, "databases");

    }

    WebAppConfig(json) {
        K.webapi_URL = json.WEBAPI_URL;
        K.CDN_URL = json.CDN_URL;
    }

    fNumber(n) {
        if (n < 1000)
            return n.toString();
        if (n < 1000000)
            return (Math.round(n / 100) / 10).toString() + "k";

        return (Math.round(n / 1000000)).toString() + "M";
    }

    LS = {
        user_name: "user_name",
        user_logged: "user_logged",
        user_expiration: "user_expiration",
        user_token: "ut",
        refresh_token: "rt",
        color: "color",

        SIGHTS_ROWS_CHUNK: "SIGHTS_ROWS_CHUNK",
        CHART_TABLE_ROWS: "CHART_TABLE_ROWS",
        CHART_WORD_CLOUD_ROWS: "CHART_WORD_CLOUD_ROWS",
        SIGHT_IMG_PATH: "SIGHT_IMG_PATH",
        SIGHT_MP3_PATH: "SIGHT_MP3_PATH",

        last_section: "last_section",
        current_section: "current_section",

        INVESTIGACION_ID: "_inv_id",
        INVESTIGACION_NAME: "_inv_nm",
    };

    WEBAPI_URL = "https://rest-api-v001.tomate.ai:12056/email-ai-automation/"//"https://emailai.humantrends.io:12056/email-ai-automation/";
    CDN_URL = "https://staticcontenttrendsights01.humantrends.io:8086/";

    webapi_URL = "https://rest-api-v001.tomate.ai:12056/email-ai-automation/"//"https://emailai.humantrends.io:12056/email-ai-automation/";
    CDN_URL = 'https://staticcontenttrendsights01.humantrends.io:8086/';  
    HEADER_APP_JSON = "application/json";
    HEADER_STRICT_ORIGIN = 'strict-origin-when-cross-origin';
}